import { PrimaryButton } from '@procurify/ui'
import styled from 'styled-components'

export const AiActionButtonStyled = styled(PrimaryButton)`
  min-height: ${(props) => props.theme.typography.pxToRem(40)};
  min-width: 0;
  padding: ${(props) => props.theme.typography.pxToRem(8)}
    ${(props) => props.theme.typography.pxToRem(16)}
    ${(props) => props.theme.typography.pxToRem(8)}
    ${(props) => props.theme.typography.pxToRem(8)};
`
